import React, { useState } from 'react';
import ParseDate from './ParseDate';
import ParseLimit from './ParseLimit';
import { DatePicker, Label } from '@fluentui/react';

const ArcDate = (props) => {

    const [fieldValue, setFieldValue] = useState(props.config.value);
    const [minValue] = useState(ParseLimit(props.config.Min));
    const [maxValue] = useState(ParseLimit(props.config.Max));

    const valueChangeHandler = (value) => {
        setFieldValue(value);
        const valueAsDate = formatAsISO(value)
        props.changeHandler(props.config.Id, valueAsDate);
        focusOutEventHandler(value);
    }

    const  formatAsISO = (d) => {
        const z = (n) => {return (n<10?'0':'')+n}

        if (d !== null && d !== undefined) {
            return d.getFullYear() + '-' + z(d.getMonth()+1) + '-' +
            z(d.getDate());
            // return d.getFullYear() + '-' + z(d.getMonth()+1) + '-' +
            // z(d.getDate()) + 'T' + z(d.getHours()) + ':' +
            // z(d.getMinutes()) + ':' + z(d.getSeconds());
        } else {
            return d;
        }
    }

    const onParseDateFromString = React.useCallback(
        (newValue) => {
            let parsedDate = ParseDate(newValue);
            if ((maxValue !== null && parsedDate > maxValue) || (minValue !== null && parsedDate < minValue)) {
                return "";
            }
            return parsedDate;
        }
    );

    // const onFormatDate = (date) => {
    //     return !date ? '' : date.getDate() + '/' + (date.getMonth() + 1) + '/' + (date.getFullYear() % 100);
    // };

    const focusOutEventHandler = (value) => {
        if (props.focusOut !== undefined) {
            const valueAsDate = formatAsISO(value)
            props.focusOut(props.config.Id, valueAsDate);
        }
    }

    const label = props.config.Label;

    let min = (minValue === undefined) ? ParseLimit(props.config.Min) : minValue;
    let max = (maxValue === undefined) ? ParseLimit(props.config.Max) : maxValue;
    const dateToDisplay = fieldValue === undefined || fieldValue === null || isNaN(Date.parse(fieldValue)) ? undefined : new Date(fieldValue);

    return (
        <Label>{label + (props.config.Required ? ' *' : '')}
        <React.Fragment>
            <DatePicker
                id={props.config.Id}
                onKeyDown={props.onKeyDown}
                placeholder={props.config.Placeholder}
                allowTextInput={true}
                onSelectDate={valueChangeHandler}
                value={dateToDisplay}
                parseDateFromString={onParseDateFromString}
                minDate={min}
                maxDate={max}
            />
        </React.Fragment>
        </Label>
    )
}

export default ArcDate;